import { IsDate, IsNotEmpty } from 'class-validator';

export class GlucoseTimeframeDto {
  @IsNotEmpty()
  @IsDate()
  startDate!: Date;

  @IsNotEmpty()
  @IsDate()
  endDate!: Date;
}
